import { defineMessages, FormattedMessage } from 'react-intl';
import Link from '@atlaskit/link';
import { xcss, Box } from '@atlaskit/primitives';
const messages = defineMessages({
  agreementHeader: {
    id: 'ooauth.bestPracticesHeader',
    defaultMessage: 'By accepting this app, you:',
    description: 'The header for oath legal terms',
  },
  agreementBulletOne: {
    id: 'oauth.bestPracticesBulletOne',
    defaultMessage:
      'Grant the app access to your data in all places you can access where the app is installed.',
    description: 'First oauth terms of agreement',
  },
  agreementBulletTwo: {
    id: 'oauth.bestPracticesBulletTwo',
    defaultMessage: 'Agree to the {privacyPolicyLink} and {termsOfUseLink}',
    description:
      'Second oath terms of agreement. The privacyPolicyLink and termsOfUseLink are replaced with actual links in the UI.',
  },
  privacyPolicy: {
    id: 'oauth.privacyPolicy',
    defaultMessage: 'privacy policy',
    description: 'Text for the privacy policy link',
  },
  termsOfUse: {
    id: 'oauth.termsOfUse',
    defaultMessage: 'terms of use',
    description: 'Text for the terms of use link',
  },
  usersConsented: {
    id: 'oauth.usersConsented',
    defaultMessage:
      '{numOfUsersConsented} {numOfUsersConsented, plural, one {user has} other {users have}} consented to using test oauth',
    description: 'How many users have already consented',
  },
});

const disclaimerStyle = xcss({
  color: 'color.text.subtle',
  font: 'font.body.small',
});

const NUM_USERS_CONSENTED = 0;

const LegalDisclaimer: React.FC = () => {
  const privacyPolicyLink = (
    <Link href="https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers">
      <FormattedMessage {...messages.privacyPolicy} />
    </Link>
  );

  const termsOfUseLink = (
    <Link href="https://www.atlassian.com/legal/atlassian-customer-agreement#intro">
      <FormattedMessage {...messages.termsOfUse} />
    </Link>
  );

  return (
    <Box xcss={disclaimerStyle}>
      <FormattedMessage {...messages.agreementHeader} tagName="p" />
      <ul>
        <li>
          <FormattedMessage {...messages.agreementBulletOne} />
        </li>
        <li>
          <FormattedMessage
            {...messages.agreementBulletTwo}
            values={{
              privacyPolicyLink,
              termsOfUseLink,
            }}
          />
        </li>
      </ul>
      <FormattedMessage
        {...messages.usersConsented}
        values={{ numOfUsersConsented: NUM_USERS_CONSENTED }}
        tagName="p"
      />
    </Box>
  );
};

export default LegalDisclaimer;
